<template>
    <div>
        <el-dialog 
        class="dialog"
        @closed="close()"
        :visible.sync="dialogVisible"
        width="50%">
        <template slot="title">
          <div class="title">
            注册成为VIP用户可查看完整课程内容
          </div>
        </template>
          <div class="dialogTitle" style="fontSize:20rem">使用第三方账号登录</div>
          <div class="choice">
            <img class="choiceImg" src="https://game-1259474362.cos.ap-shanghai.myqcloud.com/miniprogram/images_web_2.0/images_web/icon_login_qq_off.png">
            <img class="choiceImg weChat" @click="showDialog" src="https://game-1259474362.cos.ap-shanghai.myqcloud.com/miniprogram/images_web_2.0/images_web/icon_login_wechat_on.png">
            <img class="choiceImg" src="https://game-1259474362.cos.ap-shanghai.myqcloud.com/miniprogram/images_web_2.0/images_web/icon_login_weibo_off.png">
          </div>
          <div class="allow">登录即表示您同意并接受
            <router-link tag="a" target="_blank" :to="{name:'userAgreement'}">用户协议&nbsp;</router-link>&
            <router-link tag="a" target="_blank" :to="{name:'privacyPolicy'}"> 隐私政策&nbsp;</router-link>&
            <router-link tag="a" target="_blank" :to="{name:'cPrivacyPolicy'}"> 儿童隐私政策&nbsp;</router-link>
          </div>
        </el-dialog>
      <el-dialog
        class="dialog"
        :visible.sync="dialogVisible2"
        @closed="close()"

        width="50%">
          <div class="dialogTitle">微信账号登录</div>
          <div style="marginTop:3vw">
            <vue-qr v-if="loginStatus===0" :logoSrc="config.logo" :text="config.value" :size="qrSize" :margin="0"></vue-qr>
            <div class="mask" v-else-if="loginStatus===300" @click="reset">
              <div class="bgc">
              <img class="tip" src="../assets/reset.png"/></div>
            </div>
            <div class="mask" v-else>
              <img class="tip" src="../assets/OK.png"/>
            </div>
          </div>
          <div style="height:3vw"></div>
        </el-dialog>
        </div>
</template>

<script>
import VueQr from 'vue-qr'
import CryptoJS from 'crypto-js'

export default {
  components:{
    VueQr
  },
  props: ['page'],
  data(){
      return {
        dialogVisible: true,
        dialogVisible2: false,
        loginStatus:0,
        qrSize:0,
        config: {
          value: '',//显示的值、跳转的地址
          logo: "https://game-1259474362.cos.ap-shanghai.myqcloud.com/miniprogram/images_web_2.0/images_web/icon_wechat.png"//中间logo的地址
        }
      }
  },
  methods:{
    close(){
      if(!this.dialogVisible2){
        this.$parent.closeDialog();
        this.clearLoginTimer()
      }
    },
    
    reset(){
      var account="1234567890"
      var token = CryptoJS.MD5(account + new Date().getTime()).toString();
      var source="EINSIM";
      var url = `https://launcher.cluster.qcast.cn/wx/login/url?token=${token}&account=${account}&source=${source}&redirectUri=http://einsimtv.qcode.svc.cluster.local:80/utility/API/einsimtv/authority.php&extra=${account}`
      this.config.value=url
      this.loginStatus=0
      this.getLoginStatus(token)
    },
    showDialog(){
      this.dialogVisible=false
      this.loginStatus=0
      this.dialogVisible2=true
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      this.qrSize=oWidth/1280*150
      console.log(this.qrSize);
      var account="1234567890"
      var token = CryptoJS.MD5(account + new Date().getTime()).toString();
      var source="EINSIM";
      var url = `https://launcher.cluster.qcast.cn/wx/login/url?token=${token}&account=${account}&source=${source}&redirectUri=http://einsimtv.qcode.svc.cluster.local:80/utility/API/einsimtv/authority.php&extra=${account}`
      console.log(url);
      this.config.value=url
      this.getLoginStatus(token)
      },
      
  getLoginStatus(token){

    //获取扫码登录状态
    this.clearLoginTimer();

    var timeCount = 300;   //登录状态轮询

    var status1 = false;

    this.loginTimer = setInterval(() => {
      timeCount--;
      if (timeCount <= 0) {
      // if (this.timeCount <= 10) {
        this.loginStatus=300
        this.clearLoginTimer();
      } else {
        this.$axios({
          // 只传一个url，默认是get请求
          url:`https://launcher.cluster.qcast.cn/wx/login/query?token=${token}`,
          method:'get'
        }).then(result =>{
          // console.log('login_result', result, result.data.data.status,timeCount);
          if (result.data.data.status === 1 && !status1) {
            console.log('已扫码')
            status1 = true;
            // this.timeCount = 20;
            this.loginStatus=1

          } else if (result.data.data.status === 2) {
            console.log('登录成功')
            
            this.loginStatus=2
            this.dialogVisible2=false
            this.clearLoginTimer();
            this.Cookies.set('cookie', result.data.data.userInfo.unionid)
            this.$store.commit('setuniId',result.data.data.userInfo)
            this.$store.commit('login',result.data.data.userInfo.headimgurl)
            if(this.page==="index"){
                this.$router.push('../Space')
            }else{
              this.$parent.start();
            }

            
            // CommonApi.getToastHandle().hide();
            // this.loginSucReSet(result.data.userInfo);
          }
        })
    }}, 1000);
      //   var promise = CommonApi.loginStatus(this.state.token);
      //   promise.then((result) => {
      //     console.log('login_result', result, result.data.status,this.state.timeCount);
      //     if (result.data.status === 1 && !status1) {
      //       console.log('已扫码')
      //       status1 = true;
      //       // this.timeCount = 20;
      //       this.timeCount = 300;
      //       this.setState({ loginStatus: 1, timeCount: this.timeCount });
      //       login_bi("login_scan", pageName.userPage);

      //     } else if (result.data.status === 2) {
      //       console.log('登录成功')
      //       pageView("登录成功", pageType.popup, pageName.userLoginPage);
      //       this.setState({ loginStatus: 2 });
      //       this.clearLoginTimer();
      //       CommonApi.getToastHandle().hide();
      //       this.loginSucReSet(result.data.userInfo);
      //     }
      //   })
      // }
  },
  
  clearLoginTimer(){
    if (this.loginTimer) {
      clearInterval(this.loginTimer);
      this.loginTimer = null;
    }
  },
      
  }
}
</script>

<style scoped>

*{
  margin: auto;
  padding: 0;
}

.dialog{
  margin-top: 10vh;
  text-align: center;
  /* width: 44.8vw;
  height: 24vw; */
}

.dialogTitle{
  font-size: 26rem;
}
.choice{
    margin-left: 10%;
    width: 80%;
  display: flex;
  justify-content:space-between
}

.choiceImg{
  width: 6vw;
  height: 6vw;
  cursor:not-allowed;
  margin-top: 3vw;
}
.allow{
  font-size: 18rem;
  margin-top: 2vw;
}
a{
  text-decoration: none;
  cursor: pointer;
  color: #000;
}


.weChat{
  cursor:pointer
}
.mask{
  height: 11.7vw;
  width: 11.7vw;
  background-color:  #fff;
}

.tip{
  margin-top: 20%;
  /* margin-left: 30%; */
  width: 40%;
  height: auto;
}

.bgc{
  width: 100%;
  height: 100%;
  background-color:rgba(0,0,0,0.5) ;
  cursor: pointer;
}

.title{
  font-size: 36rem;
}



</style>


// WEBPACK FOOTER //
// src/components/Login.vue